export const DEFAULT_RANGE_DAYS = 60;

export const toIsoDate = (date: Date): string => {
  const yyyy = date.getUTCFullYear();
  const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(date.getUTCDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

export const lastNDaysRange = (
  days: number = DEFAULT_RANGE_DAYS,
  now: Date = new Date()
): { dos_start: string; dos_end: string } => {
  const end = new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())
  );
  const start = new Date(end);
  start.setUTCDate(start.getUTCDate() - (days - 1));
  return { dos_start: toIsoDate(start), dos_end: toIsoDate(end) };
};
